<template>
  <div class="uk-padding-small">

    <div class="uk-grid-medium uk-margin-bottom" data-uk-grid data-uk-height-match>


      <div class="uk-width-expand-1-1">
        <div class="uk-card uk-card-default uk-card-small uk-card-hover uk-flex-first@m">
          <div class="uk-card-header">
            <div class="uk-grid uk-grid-small">
              <div class="uk-width-auto"><h4>Yesterday's Detail</h4>{{yesterdayDates[0]}}</div>
              <div class="uk-width-expand uk-text-right panel-icons">
              </div>
            </div>
          </div>
          <div class="uk-card-body">
            <div class="chart-container">
              <yesterday-level1 :is-corporate="isCorporate"></yesterday-level1>
            </div>
          </div>
        </div>
      </div>

      <div class="uk-width-3-5@l">
        <div class="uk-card uk-card-default uk-card-small uk-card-hover uk-flex-first@m">
          <div class="uk-card-header">
            <div class="uk-grid uk-grid-small">
              <div class="uk-width-auto"><h4>Yesterday's Barchart</h4></div>
              <div class="uk-width-expand uk-text-right panel-icons">
              </div>
            </div>
          </div>
          <div class="uk-card-body">
            <div class="chart-container">
              <comp-sales-barchart :is-corporate="isCorporate" time-period="yesterday-bar"></comp-sales-barchart>
            </div>
          </div>
        </div>
      </div>


      <div class="uk-width-2-5@l">
        <div class="uk-card uk-card-default uk-card-small uk-card-hover uk-flex-first@m">
          <div class="uk-card-header">
            <div class="uk-grid uk-grid-small">
              <div class="uk-width-auto"><h4>Yesterday's Store Ranking </h4>{{yesterdayDates[0]}}</div>
              <div class="uk-width-expand uk-text-right panel-icons">
              </div>
            </div>
          </div>
          <div class="uk-card-body">
            <div class="chart-container">
              <store-rank-data-grid :rank-type="'Yesterday'"></store-rank-data-grid>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>


import YesterdayLevel1 from "@/Components/DetailPages/Parts/Yesterday/Components/YesterdayLevel1.vue";
import StoreRankDataGrid from "@/Components/DetailPages/Parts/Shared/StoreRankDataGrid.vue";
import CompSalesBarchart from "@/Components/DetailPages/Parts/Shared/CompSalesBarchart.vue";

export default {
  name: "YesterdayApp",
  components: {
    YesterdayLevel1,
    StoreRankDataGrid,
    CompSalesBarchart
  },
  props: {
    isCorporate: Boolean,
    yesterdayDates: Array,
  },

  methods: {
    backToOverview() {
      this.eventHub.$emit("backToOverview", true);
    },
  }

}
</script>

<style scoped>

</style>